import { render, staticRenderFns } from "./gameBetHistory.vue?vue&type=template&id=3387fba6"
import script from "./gameBetHistory.vue?vue&type=script&lang=js"
export * from "./gameBetHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports